import { render, staticRenderFns } from "./AddServicepointForm.vue?vue&type=template&id=3e940045&scoped=true"
import script from "./AddServicepointForm.vue?vue&type=script&lang=ts"
export * from "./AddServicepointForm.vue?vue&type=script&lang=ts"
import style0 from "./AddServicepointForm.vue?vue&type=style&index=0&id=3e940045&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e940045",
  null
  
)

export default component.exports